import React from 'react'

const Industria = () => {
  return (
    <div>Industria</div>
  )
}

export default Industria